import React, { useState, useEffect, useRef } from 'react'
import Skeleton from 'react-loading-skeleton';
import DatePicker, { registerLocale } from "react-datepicker";
import { de } from "date-fns/locale";
import { format, parse } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
// import "bootstrap/dist/css/bootstrap.min.css";

import { Link, useNavigate, useParams } from 'react-router-dom';
import $ from "jquery";
import "select2/dist/css/select2.min.css";
import "select2";
import Breadcrumbs from '../components/Breadcrumbs';
import Header_3 from '../headers/Header_3';
import { Turnstile } from "@marsidev/react-turnstile";
import SEO from '../components/Seo';
import Header_2 from '../headers/Header_2';
import InternerWohnungsStepform from '../components/InternerWohnungsStepform';
import ParkplatzStepForm from '../components/ParkplatzStepForm';

// Register German locale
registerLocale("de", de);


export const Parkplatz = () => {

    const [selected, setSelected] = useState("tiefgarage");
    useEffect(() => {
        $(".select2").select2();
    }, []);

    let { title } = useParams();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);
    const [headerModules, setHeaderModules] = useState(null);
    const [metaData, setMetaData] = useState(null);
    const [siedlungen, setSiedlungen] = useState([]);

    const getSiedlungen = async () => {
        setIsLoading(true)
        try {
            const response = await fetch("https://backend.bgzurlinden.ch/api/neubauprojekte-posts?pagination[limit]=100&sort[0]=Page_Titel");

            const data = await response.json();
            console.log("data?.data?.Page_Titel", data?.data);

            if (data.data) {
                setSiedlungen(data?.data?.filter((item) =>
                    item?.Page_Template !==
                    "Sanierungen"));
            }
        }
        catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }

    }

    const getPageData = async () => {
        setIsLoading(true)
        try {
            const response = await fetch("https://backend.bgzurlinden.ch/api/parkplatz-form?populate[Bannerbereich][on][header.header-2-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-2-text-bild][populate][Videominiatur]=true&populate[Bannerbereich][on][header.header-2-text-bild][populate][Video]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Button]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Videominiatur]=true&populate[Bannerbereich][on][header.header-3-titel-text-bild][populate][Video]=true&populate[Metadaten]=*");


            const data = await response.json();
            console.log('test', data?.data?.Modul);

            if (data.data) {
                setMetaData(data?.data?.Metadaten);
                setHeaderModules(data?.data?.Bannerbereich);
            }
        }
        catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }

    }

    useEffect(() => {
        getSiedlungen();
        getPageData();
    }, [])

    const [formData, setFormData] = useState({
        liegenschaft: "",
        parkingType: "tiefgarage",
        mietbeginn: "",
        anrede: "",
        firma: "",
        vorname: "",
        nachname: "",
        geburtsdatum: "",
        email: "",
        strasse: "",
        plz: "",
        ort: "",
        telefon: "",
    });

    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);


    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        // remove warning border
        setErrors((prev) => ({
            ...prev,
            [name]: false,
        }));
    };


    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [
            "liegenschaft",
            "parkingType",
            "mietbeginn",
            "anrede",
            "vorname",
            "nachname",
            "geburtsdatum",
            "email",
            "strasse",
            "plz",
            "ort",
            "telefon",
        ];

        requiredFields.forEach((field) => {
            if (!formData[field] || formData[field].trim() === "") {
                newErrors[field] = true;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    useEffect(() => {
        $(".select2").each(function () {
            const $this = $(this);

            $this.select2();

            $this.on("change", function () {
                const name = $(this).attr("name");
                const value = $(this).val();

                console.log("Changed:", name, value);

                $(this)
                    .next(".select2-container")
                    .find(".select2-selection")
                    .removeClass("warning-border");

                if (name in formData) {
                    setFormData((prev) => ({
                        ...prev,
                        [name]: value,
                    }));
                }
            });
        });

        return () => {
            const selects = $(".select2");
            selects.each(function () {
                const $el = $(this);

                // destroy only if initialized
                if ($el.data("select2")) {
                    console.log("Destroying select2 for", $el.attr("name"));
                    $el.select2("destroy");
                }
            });
        };
    }, []);

    useEffect(() => {
        $(".select2").each(function () {
            const name = $(this).attr("name");

            console.log("Validating select:", name, formData[name], errors[name]);

            if (errors[name] && formData[name].trim() === "") {
                $(this)
                    .next(".select2-container")
                    .find(".select2-selection")
                    .addClass("warning-border");
            } else {
                $(this)
                    .next(".select2-container")
                    .find(".select2-selection")
                    .removeClass("warning-border");
            }
        });
    }, [errors]);

    const [captchaToken, setCaptchaToken] = useState("");
    const [captchaError, setCaptchaError] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        console.log("Submitting form with data:", formData);
        // return;

        if (!validateForm()) {
            return;
        }

        if (!captchaToken) {
            setCaptchaError(true);
            return;
        }

        try {
            setIsSubmitting(true);

            const response = await fetch(
                `${process.env.REACT_APP_FRONTEND_URL}api/submit-freie-mietobjekte-form?pageTitle=Parkplatz`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(formData),
                }
            );

            const data = await response.json();

            console.log(data);

            if (data?.success) {
                setFormData({
                    liegenschaft: "",
                    parkingType: "tiefgarage",
                    mietbeginn: "",
                    anrede: "",
                    firma: "",
                    vorname: "",
                    nachname: "",
                    geburtsdatum: "",
                    email: "",
                    strasse: "",
                    plz: "",
                    ort: "",
                    telefon: "",
                });

                setErrors({});

                navigate("/vielen-dank");
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className='page-content'>
            {metaData && <SEO seoData={metaData} />}

            {!isLoading && (
                headerModules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "header.header-2-text-bild" && (
                            <Header_2 module={module} isLoading={isLoading} title={module?.Titel} description={module?.Beschreibung} image={module?.Bild} sectionClass="banners-wohnen" activePage='Wohnen' activeInnerPage={'Mieterservice'} />
                        )}
                    </React.Fragment>
                ))
            )}

            {!isLoading && (
                headerModules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "header.header-3-titel-text-bild" && (
                            <Header_3 module={module} title={module?.Titel} description={module?.Beschreibung} image={module?.Bild} sectionClass="banners-wohnen" activePage='Wohnen' activeInnerPage={'Mieterservice'} />
                        )}
                    </React.Fragment>
                ))
            )}

            <section class="pt-pb-10 pt-0 sec-orange-color">
                <div class="container">
                    <ParkplatzStepForm />
                </div>
            </section>
        </div>
    )
}